import { Box, Stack, Typography } from '@mui/material';
import { ObjectFieldTemplateProps } from '@rjsf/core';

export default function TableRowTemplate({ title, properties }: ObjectFieldTemplateProps) {
  if (!properties) {
    return null;
  }

  return (
    <Stack spacing={3} direction="row" alignItems="center">
      <Box flex={1}>{title}</Box>
      {properties?.map((property) => (
        <Box flex={1} key={property.name}>
          <Typography>{property.content}</Typography>
        </Box>
      ))}
    </Stack>
  );
}
